/* AdminSpeedDial.js */

import React from "react";
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import LinkIcon from "@mui/icons-material/Link";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import NotesIcon from "@mui/icons-material/Notes";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import SecurityIcon from "@mui/icons-material/Security";
import EditIcon from "@mui/icons-material/Edit";

import "./AdminSpeedDial.css";

const darkTooltipSx = {
  bgcolor: "#111",
  color: "#fff",
  fontSize: 12,
};

const PanelType = {
  ADMIN_TOKENS: 'adminTokens',
  TOKEN_CAROUSEL: 'tokenCarousel',
  ROLE: 'role',
  PROJECT_NAME: 'projectName',
};

const buildSpeedDialActionFabClassName = ({ isSelected = false, tokenType = "" } = {}) => {
  return [
    "asdFab",
    tokenType && `asdFab--${tokenType}`,
    isSelected && "asdFab--selected"
  ].filter(Boolean).join(" ");
};

const AdminSpeedDial = ({
  activePanel,
  onTogglePanel,
  onCloseAllPanels,
  onCopyProjectToken,
  onOpenSubmissionUrl,
  onOpenReviewUrl,
  onCopySubmissionUrl,
  onCopyReviewUrl,
}) => {
  return (
    <SpeedDial
      ariaLabel="Admin actions"
      className="asdSpeedDial"
      icon={<SpeedDialIcon icon={<SettingsIcon />} openIcon={<CloseIcon />} />}
      direction="down"
    >
      <SpeedDialAction
        icon={<NotesIcon />}
        tooltipTitle={activePanel === PanelType.ADMIN_TOKENS ? "Hide admin tokens" : "Show admin tokens"}
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ isSelected: activePanel === PanelType.ADMIN_TOKENS }),
        }}
        onClick={() => onTogglePanel(PanelType.ADMIN_TOKENS)}
      />

      <SpeedDialAction
        icon={<ViewCarouselIcon />}
        tooltipTitle={activePanel === PanelType.TOKEN_CAROUSEL ? "Hide carousel" : "Show carousel"}
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ isSelected: activePanel === PanelType.TOKEN_CAROUSEL }),
        }}
        onClick={() => onTogglePanel(PanelType.TOKEN_CAROUSEL)}
      />

      <SpeedDialAction
        icon={<SecurityIcon />}
        tooltipTitle={activePanel === PanelType.ROLE ? "Hide my role" : "Show my role"}
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ isSelected: activePanel === PanelType.ROLE }),
        }}
        onClick={() => onTogglePanel(PanelType.ROLE)}
      />

      <SpeedDialAction
        icon={<EditIcon />}
        tooltipTitle={activePanel === PanelType.PROJECT_NAME ? "Hide name editor" : "Edit project name"}
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ isSelected: activePanel === PanelType.PROJECT_NAME }),
        }}
        onClick={() => onTogglePanel(PanelType.PROJECT_NAME)}
      />

      <SpeedDialAction
        icon={<OpenInNewIcon />}
        tooltipTitle="Open active submission URL"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ tokenType: "submission" }),
        }}
        onClick={onOpenSubmissionUrl}
      />

      <SpeedDialAction
        icon={<OpenInNewIcon />}
        tooltipTitle="Open active review URL"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ tokenType: "review" }),
        }}
        onClick={onOpenReviewUrl}
      />

      <SpeedDialAction
        icon={<LinkIcon />}
        tooltipTitle="Copy active submission URL"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ tokenType: "submission" }),
        }}
        onClick={onCopySubmissionUrl}
      />

      <SpeedDialAction
        icon={<LinkIcon />}
        tooltipTitle="Copy active review URL"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName({ tokenType: "review" }),
        }}
        onClick={onCopyReviewUrl}
      />

      <SpeedDialAction
        icon={<ContentCopyIcon />}
        tooltipTitle="Copy project token"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName(),
        }}
        onClick={onCopyProjectToken}
      />

      <SpeedDialAction
        icon={<CloseIcon />}
        tooltipTitle="Close panels"
        TooltipProps={{ componentsProps: { tooltip: { sx: darkTooltipSx } } }}
        FabProps={{
          className: buildSpeedDialActionFabClassName(),
        }}
        onClick={onCloseAllPanels}
      />
    </SpeedDial>
  );
};

export default AdminSpeedDial;